<mat-progress-bar
    *ngIf="loading"
    mode="indeterminate"
    i18n-aria-label="@@progressbar-label"
    aria-label="Loading..."></mat-progress-bar>
